import lodash from 'lodash';

const state = () => ({
  partnerId: null,
  partnerUrl: null,
  partnerData: {},
  partnerLoading: false,
  currentMutation: {},
  userToken: '',
  region: 'CZ'
});

const getters = {
  partnerId(state) {
    return state.partnerId;
  },
  partnerData(state) {
    return state.partnerData;
  },
  currentMutation(state) {
    return state.currentMutation;
  },
  region(state) {
    return state.region;
  },
  partnerUrl(state) {
    return state.partnerUrl;
  },
  partnerLoading(state) {
    return state.partnerLoading;
  },
  userToken(state) {
    return state.userToken;
  }
};

const mutations = {
  setPartnerId(state, payload) {
    state.partnerId = payload;
  },
  setPartnerData(state, payload) {
    state.partnerData = payload;
  },
  setCurrentMutation(state, payload) {
    state.currentMutation = payload;
  },
  setRegion(state, payload) {
    state.region = payload;
  },
  setPartnerUrl(state, payload) {
    state.partnerUrl = payload;
  },
  setPartnerLoading(state, payload) {
    state.partnerLoading = payload;
  },
  setUserToken(state, payload) {
    state.userToken = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  async setPartnerId({ commit }, payload) {
    commit('setPartnerId', payload);
  },

  async setCurrentMutation({ commit }, payload) {
    commit('setCurrentMutation', payload);
  },

  async setRegion({ commit }, payload) {
    commit('setRegion', payload);
  },

  async setPartnerLoading({ commit }, payload) {
    commit('setPartnerLoading', payload);
  },

  async updatePartner({ commit, dispatch }, payload) {
    commit('setPartnerUrl', payload.partnerUrl);
    const url = '/v3/fe/partners/' + payload.partnerUrl + '/' + payload.region;
    await this.$http
      .get(url)
      .then(data => {
        commit('setPartnerData', data);
      })
      .catch(err => {
        dispatch(
          'errorModal/handleError',
          { error: err, showModal: payload.showErrorModal, code: '0x00000056' },
          { root: true }
        );
      });
  },

  async setupHrbPartner({ commit, dispatch, state }, payload) {
    dispatch('general/setHeader', payload.header, { root: true });
    dispatch('setPartnerLoading', true);
    let region = 'CZ';
    if (payload.context.$domainRegion === 'sk') {
      region = 'SK';
    }
    commit('setRegion', region);

    if (
      payload.context.params.partnerUrl === state.partnerUrl &&
      !lodash.isEmpty(state.partnerData) &&
      region === state.region
    ) {
      state.partnerData.mutations.forEach(val => {
        if (val.language === payload.context.app.i18n.locale) {
          commit('setCurrentMutation', val);
        }
      });
      dispatch('setPartnerLoading', false);
      return;
    }

    await dispatch('updatePartner', {
      partnerUrl: payload.context.params.partnerUrl,
      region,
      showErrorModal: false
    });
    const partnerData = state.partnerData || {};

    if (
      Object.keys(partnerData).length === 0 ||
      !partnerData.mutations ||
      lodash.isEmpty(partnerData.mutations) ||
      !partnerData.dateCooperationStart ||
      new Date(partnerData.dateCooperationStart).setHours(0, 0, 0, 0) >
        new Date().setHours(0, 0, 0, 0)
    ) {
      dispatch('general/setHeader', null, { root: true });
      dispatch('setPartnerLoading', false);
      payload.context.error({ statusCode: 404, message: 'Page not found' });
      return;
    }

    if (
      partnerData.authorizationStrategy === 4 &&
      payload.context.query.userToken &&
      payload.context.query.userToken.length
    ) {
      commit('setUserToken', payload.context.query.userToken);
      dispatch(
        'profile/externalPartner/setExternalPartner',
        {
          userToken: payload.context.query.userToken,
          partnerUrl: payload.context.params.partnerUrl
        },
        { root: true }
      );
    }

    if (
      payload.context.params.partnerUrl === 'vozp' &&
      payload.context.$route?.query?.userToken &&
      payload.context.$route.query.userToken.length
    ) {
      await dispatch('getUserData', payload.context.$route.query.userToken);
    }

    let currentMutation = null;

    partnerData.mutations.forEach(val => {
      if (val.language === payload.context.app.i18n.locale) {
        currentMutation = val;
        commit('setCurrentMutation', val);
      }
    });

    if (!currentMutation && partnerData.mutations.length) {
      const redirectLang = partnerData.mutations[0].language;
      payload.context.redirect(payload.context.$switchLocalePath(redirectLang));
      dispatch('setPartnerLoading', false);
      return;
    }

    if (payload.pageCheck && !currentMutation[payload.pageCheck]) {
      payload.context.redirect(payload.context.$localePath('hrbPage'));
    }

    payload.context.$gtm.push({ hrbName: partnerData.name });
    dispatch('setPartnerLoading', false);
  },

  async getUserData({ dispatch }, payload) {
    const url = '/v3/fe/web-users?partnerToken=' + payload;
    await this.$http
      .get(url, { headers: { Authorization: '' } })
      .then(data => {
        const birthYear = data.dateOfBirth.split('-')[0];

        dispatch('forms/firstName/updateFirstName', data.firstName, { root: true });
        dispatch('forms/lastName/updateLastName', data.lastName, { root: true });
        dispatch('forms/email/updateEmail', data.email, { root: true });
        dispatch('forms/phone/updatePhoneNumber', data.phone, { root: true });
        dispatch('forms/birthYear/updateBirthYear', birthYear, { root: true });
        dispatch('forms/ZipCode/updateZipCode', data.location.zip, { root: true });
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x00000057' }, { root: true });
      });
  }
};

export const hrbPartner = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
